import * as THREE from 'three'

// Module-level refs updated by FirstPersonCamera every frame.
// Read by InteractionDetector without causing React re-renders.
export const playerWorldPos = new THREE.Vector3()
export const playerNormal = new THREE.Vector3(0, 1, 0)
export let playerTheta = 0
export let playerPhi = 0
export let playerYaw = 0

export function updatePlayerPosition(pos: THREE.Vector3, normal: THREE.Vector3, theta: number, phi: number, yaw?: number) {
  playerWorldPos.copy(pos)
  playerNormal.copy(normal)
  playerTheta = theta
  playerPhi = phi
  if (yaw !== undefined) playerYaw = yaw
}

export function getPlayerTheta() { return playerTheta }
export function getPlayerPhi() { return playerPhi }
export function getPlayerYaw() { return playerYaw }
